import { useState } from 'react';

import { useGenericModal } from '..';
import {
  DeleteReportingApiCredentialModal,
  DeleteReportingApiCredentialModalProps,
} from './delete-reporting-api-credential-modal';

type Env = 'live' | 'sandbox';

export const useDeleteReportingApiCredentialModal = (
  props?: Partial<DeleteReportingApiCredentialModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const [credentialId, setCredentialId] = useState<string | undefined>();
  const [pypeId, setPypeId] = useState<string | undefined>();
  const [credentialName, setCredentialName] = useState('');
  const [env, setEnv] = useState<Env>('live');

  const modalComponent = (
    <DeleteReportingApiCredentialModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
      credentialId={credentialId}
      pypeId={pypeId}
      credentialName={credentialName}
      env={env}
    />
  );

  const openDeleteModal = (options: {
    credentialId: string;
    pypeId: string;
    credentialName: string;
    env: Env;
  }) => {
    setCredentialId(options.credentialId);
    setPypeId(options.pypeId);
    setCredentialName(options.credentialName);
    setEnv(options.env);
    openModal();
  };

  return {
    modalRef,
    openModal: openDeleteModal,
    closeModal,
    deleteReportingApiCredentialModal: modalComponent,
  };
};
